import { dateInterpolate } from "../../charts/D3ChartHoverHelpers";
import { HoverElement } from "./HoverElement";
import { max, min, select } from "d3";

export class CandleHover extends HoverElement {
  constructor(params) {
    super({ ...params });
    // Local Attributes
    this.yField = params.yField;
    this.customName = params.customName;
    this.fillColor = params.fillColor;
    this.strokeColor = params.strokeColor || "colorSel";
    this.toZero = params.toZero;
    // this.create({ ...params });
  }

  show({ xPix, selData, candleWidth, highlightCandles }) {
    let yt = this.svg.y;
    if (highlightCandles) {
      select("." + this.className)
        .style("opacity", 1)
        .attr("x", xPix - candleWidth / 2)
        .attr("y", Math.min(yt(0), yt(selData[this.yField])))
        .attr("height", Math.max(1, Math.abs(yt(0) - yt(selData[this.yField]))))
        .attr("width", candleWidth);
    } else {
      select("." + this.className).style("opacity", 0);
    }
  }

  recalculate({
    data,
    upColor,
    dnColor,
    dnColorBackground,
    upColorBackground,
    opacityDn,
    opacityUp,
    customName,
    addId = false,
    idField = "id",
    fieldStick1 = "stick",
    fieldStick2 = "stick2",
    lineWidth = 1,
    customX = false,
    xRange = [],
    offsetBandWidth = 0,
    bandWidthAux = 0,
    deltaBand = 1 / 22,
    xIsDate = false,
  }) {
    const svg = this.svg;
    let bandWidth;
    if (xIsDate === false) {
      bandWidth = svg.x.bandwidth();
    } else {
      bandWidth = bandWidthAux;
    }
    if (!upColorBackground) upColorBackground = upColor;

    if (!dnColorBackground) {
      dnColorBackground = dnColor;
    }
    const candleWidth = bandWidth * 0.7 + 1;
    const delta = (bandWidth - candleWidth) / 2;
    const deltaCustom = candleWidth * deltaBand;
    // sticks
    const sticks1Group = this.svgAux.selectAll(`.${fieldStick1}s${customName}`);
    const sticks1 = sticks1Group.selectAll("rect").data(data, (d) => d);
    svg[fieldStick1] = sticks1
      .data(data, (d) => d)
      .join(
        function(enter) {
          return enter
            .append("rect")
            .attr("stroke-width", lineWidth)
            .attr("x", function(d) {
              const x = customX
                ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                  deltaCustom -
                  lineWidth / 2 -
                  offsetBandWidth
                : svg.x(d.date) + bandWidth / 2 - offsetBandWidth;

              return !Number.isNaN(x) ? x : -100000;
            })
            .attr("y", function(d) {
              return svg.y(d.high);
            })
            .attr("height", function(d) {
              return Math.max(
                0.0000001,
                svg.y(Math.max(d.open, d.close)) - svg.y(d.high),
              );
            })
            .attr("width", 1)
            .attr(
              "class",
              (d, i) =>
                fieldStick1 + customName + "" + (addId ? +d[idField] : i),
            )
            .attr("fill-opacity", function(d) {
              return d.close >= d.open ? opacityUp : opacityDn;
            })
            .style("fill", function(d) {
              return d.close > d.open ? upColor : dnColor;
            })
            .style("shape-rendering", "crispEdges")
            .style("vector-effect", "non-scaling-stroke");
        },
        function(update) {
          return update
            .attr("x", function(d) {
              const x = customX
                ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                  deltaCustom -
                  lineWidth / 2 -
                  offsetBandWidth
                : svg.x(d.date) + bandWidth / 2 - offsetBandWidth;

              return !Number.isNaN(x) ? x : 0;
            })
            .attr("y", function(d) {
              return svg.y(d.high);
            })
            .attr("height", function(d) {
              return Math.max(
                0.0000001,
                svg.y(Math.max(d.open, d.close)) - svg.y(d.high),
              );
            })
            .attr("width", 1)
            .style("fill", function(d) {
              return d.close > d.open ? upColor : dnColor;
            });
        },
        function(exit) {
          return exit.remove();
        },
      );
    // sticks 2
    const sticks2Group = this.svgAux.selectAll(`.${"sticks2"}${customName}`);
    const sticks2 = sticks2Group.selectAll("rect").data(data, (d) => d);
    svg[fieldStick2] = sticks2.join(
      function(enter) {
        return enter
          .append("rect")
          .attr("stroke-width", lineWidth)
          .attr("x", function(d) {
            const x = customX
              ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                deltaCustom -
                lineWidth / 2 -
                offsetBandWidth
              : svg.x(d.date) + bandWidth / 2 - offsetBandWidth;
            return !Number.isNaN(x) ? x : -100000;
          })
          .attr("y", function(d) {
            return svg.y(Math.min(d.open, d.close));
          })
          .attr("height", function(d) {
            return Math.max(
              0.0000001,
              svg.y(d.low) - svg.y(Math.min(d.open, d.close)),
            );
          })
          .attr("width", 1)
          .style("fill", function(d) {
            return d.close > d.open ? upColor : dnColor;
          })
          .style("shape-rendering", "crispEdges")
          .style("vector-effect", "non-scaling-stroke");
      },
      function(update) {
        return update
          .attr("x", function(d) {
            return customX
              ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                  deltaCustom -
                  lineWidth / 2 -
                  offsetBandWidth
              : svg.x(d.date) + bandWidth / 2 - offsetBandWidth;
          })
          .attr("y", function(d) {
            return svg.y(Math.min(d.open, d.close));
          })
          .attr("height", function(d) {
            return Math.max(
              0.0000001,
              svg.y(d.low) - svg.y(Math.min(d.open, d.close)),
            );
          })
          .attr("width", 1)
          .style("fill", function(d) {
            return d.close > d.open ? upColor : dnColor;
          });
      },
      function(exit) {
        return exit.remove();
      },
    );
    // candles
    const candleGroup = this.svgAux.selectAll(`.candles${customName}`);
    const candles = candleGroup.selectAll("rect").data(data, (d) => d);
    svg["candles"] = candles.join(
      function(enter) {
        return enter
          .append("rect")
          .attr("x", function(d) {
            const x = customX
              ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                deltaCustom / 2
              : svg.x(d.date) + delta;
            return x;
          })
          .attr("y", function(d) {
            return svg.y(max([d.open, d.close]));
          })
          .attr("height", function(d) {
            const height = Math.max(
              0.000001,
              svg.y(min([d.open, d.close])) - svg.y(max([d.open, d.close])),
            );
            return height;
          })
          .attr("class", function(d, i) {
            return "candle" + customName + "" + (addId ? +d[idField] : i);
          })
          .attr("width", customX ? deltaCustom : candleWidth)
          .attr("stroke-width", lineWidth)
          .attr("stroke", function(d) {
            return d.close > d.open ? upColor : dnColor;
          })
          .style("fill", function(d) {
            return d.close > d.open ? upColorBackground : dnColorBackground;
          })
          .attr("fill-opacity", function(d) {
            return d.close > d.open ? opacityUp : opacityDn;
          });
      },
      function(update) {
        return update
          .attr("x", function(d) {
            const x = customX
              ? dateInterpolate(xRange, d.date, svg.x, svg.x.bandwidth()) +
                deltaCustom / 2
              : svg.x(d.date) + delta;
            return x;
          })
          .attr("y", function(d) {
            return svg.y(max([d.open, d.close]));
          })
          .attr("height", function(d) {
            const height = Math.max(
              0.000001,
              svg.y(min([d.open, d.close])) - svg.y(max([d.open, d.close])),
            );
            return height;
          })
          .attr("class", function(d, i) {
            return "candle" + customName + "" + (addId ? +d[idField] : i);
          })
          .attr("width", customX ? deltaCustom : candleWidth)
          .attr("stroke-width", lineWidth)
          .attr("stroke", function(d) {
            return d.close > d.open ? upColor : dnColor;
          })
          .style("fill", function(d) {
            return d.close > d.open ? upColorBackground : dnColorBackground;
          })
          .attr("fill-opacity", function(d) {
            return d.close > d.open ? opacityUp : opacityDn;
          });
      },
      function(exit) {
        return exit.remove();
      },
    );

    return svg;
  }

  create({ strokeColor, strokeWidth = 1 }) {
    this.className = "bar" + this.customName;
    this.svg.bar = this.svg.append("g");
    this.svg.bar
      .append("rect")
      .attr("class", this.className)
      .style("opacity", 0)
      .attr("stroke", strokeColor)
      .attr("stroke-width", strokeWidth)
      .style("shape-rendering", "crispEdges")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", 0)
      .attr("height", 0);
  }
}
